export default __webpack_public_path__ + "static/media/miscellaneous17.1a3cab83.png";